"use client";
import { useAppPlatformContextOptions } from './AppContextFactory2.js';
import { translateErrors } from './useReactFormController2.js';

const useReactFormController = ({ field, form, onChange, onBlur, value, errors, hasErrors, formId: propsFormId, }) => {
    const { translate } = useAppPlatformContextOptions();
    const isReactForm = field && form;
    const fieldValue = isReactForm ? form.watchValues(field) : value;
    const { error, isTouched } = isReactForm ? form.getFieldState(field) : { isTouched: undefined, error: undefined };
    const fieldErrors = isReactForm && isTouched ? error === null || error === void 0 ? void 0 : error.message : errors;
    const fieldHasError = isReactForm && fieldErrors ? true : hasErrors || !!fieldErrors;
    const formId = isReactForm ? form.formId : propsFormId;
    const onFieldChange = (value) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (isReactForm)
            form.setFieldValue(field, value);
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    };
    const onFieldBlur = () => {
        setTimeout(() => {
            if (isReactForm) {
                form.validateField(field);
                if (form.validateBehavior !== 'on-submit') {
                    form.setFieldTouched(field);
                }
            }
            onBlur === null || onBlur === void 0 ? void 0 : onBlur();
        });
    };
    const onResetFieldTouch = () => {
        if (isReactForm && isTouched) {
            form.resetTouchedField(field);
        }
    };
    const onSetError = (error) => {
        if (isReactForm) {
            form.setFieldError(field, error);
        }
    };
    return {
        onChange: onFieldChange,
        value: fieldValue,
        hasErrors: fieldHasError,
        onBlur: onFieldBlur,
        errors: translateErrors(fieldErrors, translate),
        resetFieldTouch: onResetFieldTouch,
        onSetError,
        formId,
    };
};

export { useReactFormController };
